import DateFieldFormValue from "../ReusableFormValues/DateFieldFormValue";
import DescriptionOnlyFormValues from "../ReusableFormValues/DescriptionOnlyFormValues";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { payeeMistmatchExplanationTypeArray } from "./constants";

interface Props {
  readonly: boolean;
}

const PayeeMismatchFormValues = ({ readonly }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={payeeMistmatchExplanationTypeArray}
        placeholder="Select a Payee mismatch explanation document type"
        name="secondaryDocumentType"
        label="Document sub-type"
      />
      <DateFieldFormValue readonly={readonly} maxDate={new Date()} />
      <DescriptionOnlyFormValues readonly={readonly} />
    </>
  );
};

export default PayeeMismatchFormValues;
